var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-three"},[_c('img',{attrs:{"src":require("../../../../../../../assets/img/login-success.png")}}),_c('p',[_vm._v("恭喜您，修改成功")])])
}]

export { render, staticRenderFns }